export const localeEnUs = {
  masks: {
    date: '__/__/____',
    time: '__:__',
    datetime: '__/__/____, __:__'
  }
};
